module.exports = __webpack_public_path__ + "media/images/creator/home/icon-creator-f4eecbd1622c6adff150420e04127531.svg";